/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {GenericObject} from '@ion/core/src/types/entities';

export interface IonVisionThumbnailProps {
  src?: string;
  onClick?: (data: GenericObject) => void;
  data?: GenericObject;
}

const useStyles = makeStyles(theme => ({
  ionVisionCell : {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    '&:hover'      : {
      cursor : 'pointer'
    }
  }
}));

/**
 * @IonVisionThumbnail
 *
 * Simple component that renders the IonVision generic thumbnail with the onClick
 * callback and data that gets passed to that callback when clicked.
 *
 * ```typescript
 * import {IonVisionThumbnail} from '@ion/dls/src/components/vision/IonVisionThumbnail';
 *
 *      <IonVisionThumbnail data={data}
 *        onClick={function(data) {
 *          launchIonVisionDialog(data);
 *        }} />
 * ```
 */
export const IonVisionThumbnail = ({
  src = 'assets/img/ion-vision-placeholder.png',
  onClick,
  data
}: IonVisionThumbnailProps) => {
  const classes = useStyles();
  return (
    <div className={classes.ionVisionCell}
      onClick={onClick ? function(e) {
        e.stopPropagation;
        onClick(data);
      } : undefined}>
      <img src={src} />
    </div>
  );
};

export default IonVisionThumbnail;
